import { ReportListVM } from 'civil-status/view-models/research-report';
import { HeadCell } from 'shell/components/shared/table/types';

export const headCells: HeadCell<ReportListVM, keyof ReportListVM>[] = [
  {
    id: 'holders',
    label: 'Intestatari',
  },
  {
    id: 'register',
    label: 'Registro',
  },
  {
    id: 'typeContent',
    label: 'Tipo contenuto',
  },
  {
    id: 'typology',
    label: 'Tipologia atto',
  },
  {
    id: 'dateFormation',
    label: 'Data formazione',
  },
  {
    id: 'idAnsc',
    label: 'ID Ansc',
  },
  {
    id: 'operator',
    label: 'Operatore',
  },
  {
    id: 'service',
    label: 'Servizio',
  },
  {
    id: 'state',
    label: 'Stato',
  },
];
